export const dimensions = {
  card: {
    height: 170,
    width: 290,
  },
  container: {
    width: {
      desktop: 850,
      tablet: 600,
      phone: 290,
    },
  },
  content: {
    width: 500,
  },
  dialog: {
    width: 500,
  },
  panel: {
    width: {
      desktop: 1072,
    },
  },
  drawer: {
    width: 420,
    content: {
      width: 360,
    },
  },
  header: {
    height: 70,
  },
  sectionHeader: {
    height: 110,
    width: 600,
  },
  offerGroup: {
    height: 84,
  },
  tabs: {
    height: 52,
  },
  token: {
    margin: 20,
    width: {
      smallPhone: 280,
      phone: 320,
    },
  },
  table: {
    cell: {
      marginLeft: 16,
      width: {
        v1: 262,
        v2: 242,
        v3: 124,
        v4: 104,
        v5: 84,
        v6: 60,
        v7: 28,
        v8: 24,
      },
    },
  },
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/theme/dimensions.ts